module.exports = {"230321100":"鸡东镇","230321101":"平阳镇","230321102":"向阳镇","230321103":"哈达镇","230321104":"永安镇","230321105":"永和镇","230321106":"东海镇","230321107":"兴农镇","230321200":"鸡林乡","230321205":"明德乡","230321206":"下亮子乡","230321400":"林业局","230321500":"八五一零农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230321.json
// module id = 801
// module chunks = 0